var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-popup',{attrs:{"value":_vm.value,"round":"","close-on-click-overlay":false,"transition-appear":""}},[_c('div',{staticClass:"ft-popup"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }